import BaseService from './BaseService'

class ExpenseService extends BaseService {
  constructor () {
    super('/projects')
  }

  list (projectId, params = {}) {
    return this.customRequest('get', `/${projectId}/expenses`, null, { params })
  }

  create (projectId, payload) {
    return this.customRequest('post', `/${projectId}/expenses`, payload)
  }

  get (projectId, expenseId) {
    return this.customRequest('get', `/${projectId}/expenses/${expenseId}`)
  }

  update (projectId, expenseId, payload) {
    return this.customRequest('put', `/${projectId}/expenses/${expenseId}`, payload)
  }

  delete (projectId, expenseId) {
    return this.customRequest('delete', `/${projectId}/expenses/${expenseId}`)
  }

  uploadReceiptForAnalysis (projectId, file) {
    const form = new FormData()
    form.append('file', file)
    return this.customRequest('post', `/${projectId}/expense-receipts`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }

  getReceiptAnalysis (projectId, token) {
    return this.customRequest('get', `/${projectId}/expense-receipts/${token}`)
  }

  discardReceipt (projectId, token) {
    return this.customRequest('delete', `/${projectId}/expense-receipts/${token}`)
  }

  attachmentUrl (projectId, expenseId, attachmentId) {
    return this.customRequest('get', `/${projectId}/expenses/${expenseId}/attachments/${attachmentId}/url`)
  }
}

export default new ExpenseService()
